import { getCustomerLogoPath } from './customer';

/* initGoogleJobs
* JOB_POSTING_SCHEMA is appended in a script tag in order for Google web crawler
* to index applications.
* To test structured data (JOB_POSTING_SCHEMA), run generated data in SDTT:
* https://search.google.com/structured-data/testing-tool/u/0/
* Docs on proper schema building for JobPosting:
* 1. https://developers.google.com/search/docs/data-types/job-posting
* 2. https://schema.org/JobPosting
* */
export const initGoogleJobs = (appProps) => {
  const { job, org } = appProps;

  const today = new Date();
  const month = today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
  const day = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const datePosted = `${today.getFullYear()}-${month}-${day}`;

  const compensationTypes = {
    HOURLY: 'HOUR',
    ANNUAL: 'YEAR',
  };
  const JOB_POSTING_SCHEMA = {
    '@context': 'http://schema.org/',
    '@type': 'JobPosting',
    title: job.title,
    description: job.description,
    datePosted,
    identifier: {
      '@type': 'PropertyValue',
      name: org.name,
      value: job.job_hash,
    },
    hiringOrganization: {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.website,
      logo: getCustomerLogoPath(org),
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: job.city,
        addressRegion: job.state,
        postalCode: job.officeZipCode,
        streetAddress: job.officeStreet,
        addressCountry: 'US',
      },
    },
    // Recommended
    employmentType: job.employmentType,
    baseSalary: job.compensationType && job.shouldPublishCompensation && {
      '@type': 'MonetaryAmount',
      currency: 'USD',
      value: {
        '@type': 'QuantitativeValue',
        value: job.compensationLow,
        unitText: compensationTypes[job.compensationType],
      },
    },
  };

  const {
    title, hiringOrganization, jobLocation,
  } = JOB_POSTING_SCHEMA;

  if (title && datePosted && hiringOrganization && jobLocation) {
    const head = document.getElementsByTagName('head')[0];
    // Edit <title> tag to include job title and tagline
    const htmlTitle = document.getElementsByTagName('title')[0];
    htmlTitle.innerText = `${org.name} - ${job.title} in ${job.city}, ${job.state} | Team Engine`;
    // Add meta tag for description
    const metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'description');
    metaTag.setAttribute('content', job.tagline);
    head.appendChild(metaTag);
    // Add Google Jobs schema
    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.innerHTML = JSON.stringify(JOB_POSTING_SCHEMA);
    head.appendChild(scriptTag);
  }
};
